module.exports = function ($q, $timeout, abnLookupService) {
    return {
        scope: {
            updateResponse: '&',
            setLoadingStatus: '&',
        },
        require: '^ngModel',
        restrict: 'A',
        link: (scope, elem, attr, ctrl) => {
            ctrl.$asyncValidators.invalidError = () => {
                if (ctrl.$viewValue) {
                    const loadingTimeout = $timeout(() => scope.setLoadingStatus({ status: true }), 1000);
                    return abnLookupService.lookupAbn(ctrl.$viewValue.replace(/[\s]+/g, '')).then((res) => {
                        scope.updateResponse({ res });
                        return res.Success
                            ? $q.resolve()
                            : $q.reject();
                    }, (err) => {
                        scope.updateResponse({ res: err.data.ResponseStatus });
                        return $q.reject();
                    }).finally(() => {
                        $timeout.cancel(loadingTimeout);
                        scope.setLoadingStatus({ status: false });
                    });
                }
                return $q.reject();
            };
        },
    };
};



// WEBPACK FOOTER //
// ./src/auth/abn/abn-validator.directive.js